<template>
    <div class="enterprise_culture">
        <div class="culture_content">
            <div class="content_title wow zoomIn">企业文化</div>
            <el-row >
                <el-col  
                    v-for="(item, index) in dataList1"
                    :key="index" 
                    :md="8" 
                    :sm="12"
                    :xs="12">
                    <div class="company_label">
                        {{item}}
                        <div class="line"></div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>    
</template>

<script>
import { WOW } from 'wowjs'
export default {
  data() {
    return {
        dataList1: ['客户第一','诚信服务','团队协作','精准高效','拥抱变化','智创未来']
    }
  },
  mounted() {
    new WOW().init()
  },
}
</script>  

<style lang="scss" scoped>
.enterprise_culture{
    height: calc(100vh);
    background-image: url('../../assets/img/business/contentbg.png');
    background-position: 0 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // overflow: hidden;
    @media screen and (max-width: 1200px) {
        height:auto;
    }
    @media screen and (max-width: 768px) {
        height:auto;
    }
    .culture_content{
        width: 80%;
        margin: 0 auto;
        .content_title{
            padding: 100px 0 120px;  
            box-sizing: border-box;
            font-size: 48px;
            font-family: Adobe Heiti Std, Adobe Heiti Std-R;
            font-weight: bold;
            text-align: left;
            color: #2c2c2c;
            letter-spacing: 13.33px;
            text-align: center ;
            @media screen and (max-width: 1200px) {
                font-size: 30px;
            }
            @media screen and (max-width: 768px) {
                font-size: 22px;
                padding: 10px 0 20px;
            }
        }
        .company_label{
        // width: 140px;
        // width: 353px;
        padding: 50px;
        box-sizing: border-box;
        margin-bottom:40px ;
        margin-left: 80px;
        // height: 128px;
        text-align: center;
        // opacity: 0.05;
        background: rgb(81, 80, 80,0.1);
        font-size: 32px;
        font-family: Adobe Heiti Std, Adobe Heiti Std-R;
        font-weight: normal;
        color: #2c2c2c;
        @media screen and (max-width: 1200px) {
            font-size: 22px;
        }
        @media screen and (max-width: 768px) {
            padding: 10px;
            margin-bottom:20px;
            font-size: 18px;
            margin-left: 20px;
        }
        .line{
            margin-left: 5px;
            width: 57px;
            height: 4px;
            background: #813536;
            margin-top: 2px;
            @media screen and (max-width: 1200px) {
                margin-left: 24%;
                width: 36px;
                height: 2px;
                background: #813536;
            }
            @media screen and (max-width: 768px) {
                margin-left: 22%;
                width: 32px;
                height: 1px;
                background: #813536;
            }
        }
        // line-height: 12px;
        // letter-spacing: 3.67px;
    }

    }
    
}

</style>